import React, { useEffect, useState } from "react";
import { useCaseManagement } from "./store";
import moment from "moment";
import { Badge, Button } from "antd";
import ShowCustomer from "modules/dashboards/actionables/ShowCustomer";
import { isDownloadDisabled, statusTagColor } from "modules/utilities/utility";
import SoftBadge from "modules/common/SoftBadge";
import CardDiv from "modules/common/card-div/CardDiv";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import PaginationDiv from "modules/pagination/PaginationDiv";
import TagFilter from "./TagFilter";
import { toast } from "react-toastify";
import PlaceHolderActionable from "modules/dashboards/actionables/PlaceHolderActionable";

function AllLeadsTag() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageNumber = searchParams.get("pageNumber") || null;
  const tag = searchParams.get("tagName") || null;
  const [showCustomerInFull, setShowCustomerInFull] = useState(false);
  const navigate = useNavigate();
  const [docData, setDocData] = useState();
  const [leadDetails, setLeadDetails] = useState([]);
  const [activeId, setActiveId] = useState();
  const [selectedTag, setSelectedTag] = useState("");
  const {
    fetchSlotTagBooking,
    slotTagData,
    slotTagLoading,
    fetchSlotTagDownload,
  } = useCaseManagement();
  const [page, newPage] = useState(1);
  const [pageState, setPageState] = useState(false);

  useEffect(() => {
    if (tag && pageNumber) {
      fetchSlotTagBooking(tag, pageNumber);
    }
  }, [pageNumber, tag]);

  useEffect(() => {
    newPage(+pageNumber || 1);
  }, [pageNumber]);

  useEffect(() => {
    if (slotTagData?.data?.length) {
      setDocData(slotTagData?.data?.[0] || []);
      setActiveId(slotTagData?.data?.[0]?.id || []);
    }
  }, [slotTagData]);

  useEffect(() => {
    if (pageState) {
      navigate(
        `/case-management/all-cases-tag?pageNumber=${page}&tagName=${
          selectedTag || tag
        }`
      );
    }
    setPageState(true);
  }, [page, selectedTag, tag]);

  const handleClick = () => {
    fetchSlotTagDownload(selectedTag, toast);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <h3>All Lead (Tag)</h3>
          <div className="d-flex gap-3 align-items-center">
            <TagFilter
              selectedTag={selectedTag}
              setSelectedTag={setSelectedTag}
              tag={tag}
            />
            <Button onClick={handleClick} disabled={isDownloadDisabled}>Download</Button>
          </div>
        </div>
      }
      component={
        slotTagData?.data?.length && (
          <Row>
            <Col
              md={7}
              className="scrollable-container"
              style={{
                height: "78vh",
                opacity: showCustomerInFull ? 0 : 1,
                width: showCustomerInFull ? "0" : "45%",
                transition: "width 0.3s ease, opacity 0.3s ease",
                overflowY: "hidden",
              }}
            >
              <Row className="border rounded-top py-3 mx-2 table-head fw-bold">
                <Col md={2} className="d-flex gap-2">
                  <span>Name</span>
                </Col>
                <Col md={2} className="text-center">
                  Status
                </Col>
                <Col md={2}>Form Status</Col>
                <Col md={2} className="text-center">
                  Last form fill date
                </Col>
                <Col md={2} className="text-center">
                  Created
                </Col>
                <Col md={2}>Assigned To</Col>
              </Row>
              <div
                style={{ height: "60vh", overflowY: "scroll" }}
                className="scrollable-container"
              >
                {slotTagLoading ? (
                  <PlaceHolderActionable />
                ) : (
                  slotTagData?.data?.map((lead, index) => {
                    return (
                      <Row
                        className={`border border-top-0 table-row ${
                          index === leadDetails.length - 1 && `rounded-bottom`
                        } py-2 ms-2 me-1`}
                      >
                        <Col md={2} className=" px-2">
                          <div className="d-flex ">
                            <span
                              className="cursor-pointer text-capitalize text-primary fw-bold fs-1"
                              onClick={() => {
                                setActiveId(lead.id);
                                setDocData(lead);
                              }}
                            >
                              {lead?.user?.first_name}
                            </span>
                          </div>
                          <div className="w-100 ">
                            {lead?.user?.phone_number}
                          </div>
                        </Col>
                        <Col md={2} className="text-center">
                          <SoftBadge
                            bg={statusTagColor[lead.status]}
                            key={lead.status}
                          >
                            {lead.status && lead.status.toUpperCase()}
                          </SoftBadge>
                        </Col>
                        <Col md={2} className="text-center">
                          <div className="text-capitalize">
                            {lead.form_status}
                          </div>
                        </Col>
                        <Col md={2} className="text-center">
                          <div>
                            {moment(lead.last_form_fill_date).format(
                              "DD MMM YYYY, hh:mm a"
                            )}
                          </div>
                        </Col>
                        <Col md={2} className="text-center">
                          <div>
                            {moment(lead.created_at).format(
                              "DD MMM YYYY, hh:mm a"
                            )}
                          </div>
                        </Col>
                        <Col md={2} className="text-center">
                          <div>{lead?.assignment?.first_name}</div>
                          <div>
                            <Badge
                              count={lead?.assignment?.level}
                              style={{
                                backgroundColor: "#dcfce7",
                                color: "#166534",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    );
                  })
                )}
              </div>
              <Row>
                <PaginationDiv
                  paginationData={{
                    pageCount: slotTagData?.pagination?.pageCount || 1,
                    page: page,
                  }}
                  newPage={newPage}
                />
              </Row>
            </Col>

            <Col
              className="p-0 mt-n3"
              style={{
                height: "80vh",
                width: showCustomerInFull ? "100%" : "56%",
                transition: "width 0.3s ease",
                overflow: "hidden",
              }}
            >
              <ShowCustomer
                user={docData}
                caseId={activeId}
                isCaseManagement={"true"}
                showCustomerInFull={showCustomerInFull}
                setShowCustomerInFull={setShowCustomerInFull}
              />
            </Col>
          </Row>
        )
      }
    />
  );
}

export default AllLeadsTag;
